exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail[data-v-381c2baf]{height:500px}.detail[data-v-381c2baf] .el-table__body-wrapper{height:90%!important}", ""]);

// exports
